export default "__VITE_ASSET__fPsLVahs__"